import { tokens, webDarkTheme } from "@fluentui/react-components";

import { M365PulseTheme } from "./M365PulseTheme.types";

/**
 * Dark theme to add custom settings like colors.
 */
export const M365PulseWebDarkTheme: M365PulseTheme = {
    /* Color tokens */
    ...webDarkTheme,
    colorNeutralBackground: "#141414",
    siteHeaderBackgroundColor: tokens.colorNeutralBackground1Selected,
    versionButtonBackgroundColor: tokens.colorPaletteMarigoldBackground2,
    menuHoverBackgroundColor: "#FDC93E",
    colorPaletteGreenForeground10: "#0E700E",
    colorPaletteYellowBorder3: tokens.colorPaletteMarigoldBackground2,
    colorPaletteYellowBorder3Ground: "rgba(255, 222, 137, 0.3)",
    colorPaletteLightGreenBorder3: "#10810D",
    colorPaletteLightGreenBorder3Ground: "rgba(107, 228, 127, 0.3)",
    colorPaletteRedBorder3: tokens.colorStatusDangerBackground3,
    colorPaletteRedBorder3Ground: "rgba(240, 95, 95, 0.3)",
    selectedBarYellowForeground: "#efb839",
    colorPaletteBlueForeground1: "#0F6CBD",
    colorPaletteOrangeForeground1: "#FE9900",
    appLargeLayoutLeftSpacing: "50px",
    appLargeLayoutLeftNegativeSpacing: "-50px",
    appLargeLayoutRightSpacing: "30px",
    appLargeLayoutRightNegativeSpacing: "-30px",
    appLargeLayoutTopSpacing: "40px",
    appLargeLayoutBottomSpacing: "25px",
    appLargeLayoutBottomNegativeSpacing: "-25px",
    appSmallLayoutLeftSpacing: "5px",
    appSmallLayoutLeftNegativeSpacing: "-5px",
    appSmallLayoutRightSpacing: "5px",
    appSmallLayoutRightNegativeSpacing: "-5px",
    appSmallLayoutTopSpacing: "10px",
    appSmallLayoutBottomSpacing: "15px",
    appSmallLayoutBottomNegativeSpacing: "-15px",
    spacingVerticalLNudge: "14px",
    spacingHorizontalLNudge: "14px",
    borderRadiusXXLarge: "10px"
};
